/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */

export enum INTEGRATIONS_NAMES {
	GA = 'ga',
	SCRIPT = 'script',
	CUSTOM_TRACKER = 'customTracker',
}

export enum INTEGRATIONS_FIELD {
	GA_UNIVERSAL = 'gaUniversal',
	GA4 = 'ga4',
	HEAD_SCRIPT = 'headScript',
	BODY_SCRIPT = 'bodyScript',
	CUSTOM_TRACKER_URL = 'customTrackerUrl',
}

export enum INTEGRATIONS_PAGE_VIEW {
	DEFAULT = 'DEFAULT',
	SCRIPT = 'SCRIPT',
	GOOGLE_ANALYTICS = 'GOOGLE_ANALYTICS',
	CUSTOM_TRACKER = 'CUSTOM_TRACKER',
}

const INTEGRATIONS_PAGE_TITLE_MAP = {
	[INTEGRATIONS_PAGE_VIEW.DEFAULT]: 'default',
	[INTEGRATIONS_PAGE_VIEW.SCRIPT]: INTEGRATIONS_NAMES.SCRIPT,
	[INTEGRATIONS_PAGE_VIEW.GOOGLE_ANALYTICS]: INTEGRATIONS_NAMES.GA,
	[INTEGRATIONS_PAGE_VIEW.CUSTOM_TRACKER]: INTEGRATIONS_NAMES.CUSTOM_TRACKER,
};

export const CUSTOM_TRACKER_OPTIONS = {
	STORY_NAME: { value: '$STORY_NAME', label: 'Story name' },
	CARD_NAME: { value: '$CARD_NAME', label: 'Card name' },
	PLATFORM: { value: '$PLATFORM', label: 'Platform' },
	REFERRER: { value: '$REFERRER', label: 'Referrer' },
	RESOLUTION: { value: '$RESOLUTION', label: 'Resolution' },
} as const;

export type IntegrationListItem = {
	id: INTEGRATIONS_NAMES;
	viewId: INTEGRATIONS_PAGE_VIEW;
	icon: 'google-analytics' | 'script' | 'custom-tracker';
	path: (version: string | undefined) => string;
	translateKey: string;
	fields: INTEGRATIONS_FIELD[];
};

const INTEGRATIONS_LIST: IntegrationListItem[] = [
	{
		id: INTEGRATIONS_NAMES.GA,
		viewId: INTEGRATIONS_PAGE_VIEW.GOOGLE_ANALYTICS,
		translateKey: INTEGRATIONS_PAGE_TITLE_MAP[INTEGRATIONS_PAGE_VIEW.GOOGLE_ANALYTICS],
		icon: 'google-analytics',
		path: (version: string | undefined) =>
			version ? `storyVersions.${version}.settings.integrations.${INTEGRATIONS_NAMES.GA}` : INTEGRATIONS_NAMES.GA,
		fields: [INTEGRATIONS_FIELD.GA_UNIVERSAL, INTEGRATIONS_FIELD.GA4],
	},
	{
		id: INTEGRATIONS_NAMES.SCRIPT,
		viewId: INTEGRATIONS_PAGE_VIEW.SCRIPT,
		translateKey: INTEGRATIONS_PAGE_TITLE_MAP[INTEGRATIONS_PAGE_VIEW.SCRIPT],
		icon: 'script',
		path: (version: string | undefined) =>
			version
				? `storyVersions.${version}.settings.integrations.${INTEGRATIONS_NAMES.SCRIPT}`
				: INTEGRATIONS_NAMES.SCRIPT,
		fields: [INTEGRATIONS_FIELD.HEAD_SCRIPT, INTEGRATIONS_FIELD.BODY_SCRIPT],
	},
	{
		id: INTEGRATIONS_NAMES.CUSTOM_TRACKER,
		viewId: INTEGRATIONS_PAGE_VIEW.CUSTOM_TRACKER,
		translateKey: INTEGRATIONS_PAGE_TITLE_MAP[INTEGRATIONS_PAGE_VIEW.CUSTOM_TRACKER],
		icon: 'custom-tracker',
		path: (version: string | undefined) =>
			version
				? `storyVersions.${version}.settings.integrations.${INTEGRATIONS_NAMES.CUSTOM_TRACKER}`
				: INTEGRATIONS_NAMES.CUSTOM_TRACKER,
		fields: [INTEGRATIONS_FIELD.CUSTOM_TRACKER_URL],
	},
];

class IntegrationsFacade {
	public items = INTEGRATIONS_LIST;
	public views = INTEGRATIONS_PAGE_VIEW;
	public titles = INTEGRATIONS_PAGE_TITLE_MAP;

	public getFieldById(id: INTEGRATIONS_PAGE_VIEW) {
		return this.items.find(item => item.viewId === id);
	}

	public getFields(version: string | undefined = undefined) {
		const result = <Record<IntegrationListItem['fields'][number], { name: string }>>this.items.reduce(
			(acc, item) => {
				const fields = item.fields.reduce((accumulator, field: IntegrationListItem['fields'][number]) => {
					accumulator[field] = { name: `${item.path(version)}.${field}` };
					return accumulator;
				}, {});
				// eslint-disable-next-line no-param-reassign
				acc = { ...acc, ...fields };

				return acc;
			},
			{}
		);

		return result;
	}
}

export default new IntegrationsFacade();
